import React from "react";
import styles from "./styles.module.scss";

interface Props {
  title: string;
  onClick: () => void;
  disabled?: boolean;
  width?: boolean;
}

const WhiteButton: React.FC<Props> = (props) => {
  return (
    <button
      className={`${styles.button} ${props.width ? styles.width : ""}`}
      onClick={props.onClick}
      disabled={props.disabled}
      type="button"
    >
      {props.title}
    </button>
  );
};

export default WhiteButton;
